import React from "react";
import CodeBlock from "../Code";
const HealthDescription2 = () => {
  return (
    <>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3 className="sub-0">1. 국민건강보험 공동인증서 등록</h3>
          <p>
            국민건강보험 공동인증서 요청 API를 사용하기 위해 먼저 다음 URI를
            POST 방식으로 호출해야 합니다.
          </p>
          <CodeBlock code={"POST /register_cert"}></CodeBlock>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>Request</h3>
          <p>
            공동인증서인증에 필요한 요청헤더에 다음과 같은 파라미터를
            작성해야합니다.
          </p>
          <CodeBlock
            code={`
          [HTTP Request Header]
          {
                          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                          "x-ncp-apigw-api-key": accessKey,
          },`}
          ></CodeBlock>
          <p>
            공동인증서등록 API에 필요한 요청 본문에 다음과 같은 파라미터를
            작성해야 합니다.
          </p>
          <CodeBlock
            code={`
          [HTTP Request Body]
          {
                "pubkey_b64 ": "string",
                "prikey_b64 " : "string",
                "prikey_pw " :"string",
                "jumin1 " :"string",
                "jumin2 " :"string"
          }`}
          ></CodeBlock>
          <p>다음은 요청 본문 파라미터에 대한 설명입니다.</p>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">Field</th>
                  <th scope="col">Type</th>
                  <th scope="col">필수여부</th>
                  <th scope="col">설명</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ color: `#CE4241` }}>pubkey_b64</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>공동인증서 공개키의 base64 인코딩된 문자열</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>prikey_b64</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>공동인증서 개인키의 base64 인코딩된 문자열</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>prikey_pw </td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>공동인증서의 비밀번호</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>jumin1</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>주민등록번호 앞6자리</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>jumin2</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>주민등록번호 뒷7자리</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>Response</h3>
          <p>공동인증서인증 하면 아래와 같은 데이터를 보냅니다.</p>
          <p>다음은 정상적인 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <CodeBlock
            code={`Content-Type: application/json

              [HTTP Response Body]
              {
                "code": "REGISTER_CERT:SUCCESS",
                "msg": "string"                                           }
              `}
          ></CodeBlock>
          <p>다음은 오류가 발생한 요청 처리에 대한 HTTP 응답 예입니다.</p>

          <p>
            응답 본문의 분석된 결과 “data(JSON)”는 다음과 같은 내용으로 이루어져
            있습니다.
          </p>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">JSON key</th>
                  <th scope="col">설명</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>code</td>
                  <td>인증결과코드</td>
                </tr>
                <tr>
                  <td>msg</td>
                  <td>확인 메시지</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>오류코드</h3>
          <p>공동인증서인증 API의 오류 목록은 다음과 같습니다.</p>
          <CodeBlock
            code={`[HTTP Response Body]
          {
                  "error": {
                          "errorCode": "210",
                          "message": "Permission Denied",
                          "details": 오류 메세지                                                   }
          }
          `}
          ></CodeBlock>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">http status</th>
                  <th scope="message">message</th>
                  <th scope="col">detail</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>210 </td>
                  <td>Permission Denied </td>
                  <td>유효하지 않은 API Key </td>
                </tr>
                <tr>
                  <td>420</td>
                  <td>Field required </td>
                  <td>Field required </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3 className="sub-1">2. 국민건강보험 공동인증서 API 로그인</h3>
          <p>
            국민건강보험 공동인증서등록 API를 사용하기 위해 다음 URI를
            POST방식으로 호출해야 합니다.
          </p>
          <CodeBlock code={"POST /login"}></CodeBlock>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>Request</h3>
          <p>
            국민건강보험 공동인증서등록 API에 필요한 요청 헤더에 다음과 같은
            파라미터를 작성해야 합니다.
          </p>
          <CodeBlock
            code={`
          [HTTP Request Header]
          {
                          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                          "x-ncp-apigw-api-key": accessKey,
          },`}
          ></CodeBlock>
          <p>
            국민건강보험 공동인증서등록 API에 필요한 요청 본문에 다음과 같은
            파라미터를 작성해야 합니다.
          </p>
          <CodeBlock
            code={`
          [HTTP Request Body]
          {
              "pubkey_b64 ": "string",
              "prikey_b64 " : "string",
              "prikey_pw " :"string",
          }`}
          ></CodeBlock>
          <p>다음은 요청 본문 파라미터에 대한 설명입니다.</p>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">Field</th>
                  <th scope="col">Type</th>
                  <th scope="col">필수여부</th>
                  <th scope="col">설명</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ color: `#CE4241` }}>pubkey_b64</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>공동인증서 공개키의 base64 인코딩된 문자열</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>prikey_b64</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>공동인증서 개인키의 base64 인코딩된 문자열</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>prikey_pw</td>
                  <td style={{ color: `#5DAE46` }}>String</td>
                  <td>O</td>
                  <td>공동인증서의 비밀번호</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>Response</h3>
          <p>
            국민건강보험 공동인증서등록 API는 아래와 같은 데이터를 보냅니다.
          </p>
          <p>다음은 정상적인 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <CodeBlock
            code={`[HTTP Response Body]
              {
                "auth_code": "string",
                "code": "LOGIN:SUCCESS",
                "msg": "string"
              }
              `}
          ></CodeBlock>
          <p>다음은 오류가 발생한 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <p>
            응답 본문의 분석된 결과 “data(JSON)”는 다음과 같은 내용으로 이루어져
            있습니다.
          </p>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">JSON key</th>
                  <th scope="col">설명</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>code</td>
                  <td>인증결과코드</td>
                </tr>
                <tr>
                  <td>msg</td>
                  <td>확인 메시지</td>
                </tr>
                <tr>
                  <td>auth_code </td>
                  <td>인증에 필요한 기타 데이터</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>오류코드</h3>
          <p>국민건강보험 공동인증서등록 API의 오류 목록은 다음과 같습니다.</p>
          <CodeBlock
            code={`[HTTP Response Body]
          {
                  "error": {
                          "errorCode": "210",
                          "message": "Permission Denied",
                          "details": 오류 메세지                                                   }
          }`}
          ></CodeBlock>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">http status</th>
                  <th scope="message">message</th>
                  <th scope="col">detail</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>210 </td>
                  <td>Permission Denied </td>
                  <td>유효하지 않은 API Key </td>
                </tr>
                <tr>
                  <td>420</td>
                  <td>Field required </td>
                  <td>Field required </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
export default HealthDescription2;
